import initialState from './initialState';
import {
  CLEAR_SUBMISSION_ATTACHMENTS,
  SET_FILES_TO_BE_UPLOADED,
  SET_FAILED_FILES
} from '../actions/actionTypes';

export default function attachments(state = initialState.attachments, action) {
  switch (action.type) {
    case CLEAR_SUBMISSION_ATTACHMENTS:
      return initialState.attachments;
    case SET_FAILED_FILES:
      return {
          ...state,
          failed: [ ...state.failed, action.file ]
        };
    case SET_FILES_TO_BE_UPLOADED:
      return {
        ...state,
        forUploading: [ ...state.forUploading, action.files ]
      };
    default:
      return state;
  }
}
